import { render, staticRenderFns } from "./bannerdetails.vue?vue&type=template&id=0f5f5aee&scoped=true&"
import script from "./bannerdetails.vue?vue&type=script&lang=js&"
export * from "./bannerdetails.vue?vue&type=script&lang=js&"
import style0 from "./bannerdetails.vue?vue&type=style&index=0&id=0f5f5aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f5aee",
  null
  
)

export default component.exports